import { HttpEventType } from '@angular/common/http';
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { ApiResponse } from 'src/app/shareModule/models/common.model';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { CommonService } from 'src/app/shareModule/services/common.service';
import { CustomerService } from 'src/app/shareModule/services/customer.service';
import { LocalServiceService } from 'src/app/shareModule/services/local-service.service';
import { MemberNotificationService } from 'src/app/shareModule/services/member-notification.service';
import { RoleService } from 'src/app/shareModule/services/roles/role.service';
import { SharedService } from 'src/app/shareModule/services/shared.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import { VidplayerComponent } from '../../community/vidplayer/vidplayer.component';
import { filter, Subject, take, takeUntil } from 'rxjs';
import {
  MatBottomSheet,
  MatBottomSheetRef,
} from '@angular/material/bottom-sheet';
import { Overlay } from '@angular/cdk/overlay';

@Component({
  selector: 'app-marketplace-recommendation',
  templateUrl: './recommendation.component.html',
  styleUrls: [
    './recommendation.component.scss',
    '../marketplace.component.scss',
  ],
})
export class MarketplaceRecommendationComponent implements OnInit {
  constructor(
    private modalService: NgbModal,
    private auth: AuthServiceService,
    private toastr: ToastrService,
    private local: LocalServiceService,
    private memberNotificationService: MemberNotificationService,
    private _sanitizer: DomSanitizer,
    private roleService: RoleService,
    private customerService: CustomerService,
    private commonService: CommonService,
    private sharedService: SharedService,
    private bottomSheet: MatBottomSheet,
    private overlay: Overlay
  ) {}

  @Input() productData: any;

  public selectedRecommendation: any = {
    showCommentBox: false,
    commentText: '',
    comments: [],
  };
  @Output() changeRecommend = new EventEmitter<any>();

  @Output() addClick = new EventEmitter();

  @Input()
  showAddBtn: boolean = true;

  @Input()
  youtubeIframes: SafeHtml[] = []

  
  public addClicked() {
    this.addClick.next(true);
  }
  public recommendMessage: any = '';
  public isUserDisabled: boolean = false;
  public appUserId: number = 0;
  public youtubeLink: string = '';
  public isLogin: number = 0;
  public suggestionBase64: any = null;
  public suggestionAttachment: any = null;
  public memberMessage: string = '';
  public type: string = '';
  public productSuggestions: any = null;
  public selectedAttachProduct: any = '';
  public endTime: any = '';
  public selectedProductForRecommend: any = null;
  public currentUserNoRecommendation: any = 3;
  public imgUrl: string = environment.ImageUrl;

  viewRecommend: boolean = true;
  @ViewChild('view_recommendation_modal')
  view_recommendation_modal: TemplateRef<any>;

  private destroy$ = new Subject<void>();
  timeout1: any;
  ngOnInit(): void {
    this.sharedService.openExperience$
      .pipe(filter((data) => !!data))
      .subscribe((data: any) => {
        console.log(data);
        if (data && !this.modalRef) {
          this.openSuggestionInModal(data, this.view_recommendation_modal);
        }
      });

    this.commonService.countOfExperiences = 0;
    this.local.getUserDetailsObserver().subscribe((user) => {
      if (user?.id) {
        this.isUserDisabled = user?.isDisabled;
        this.appUserId = user?.id;
        this.isLogin = user ? 1 : 0;
      }
    });
    this.getProductSuggestions(this.productData?.id);
    // setTimeout(() => {
    // }, 3000);
  }

  ngOnDestroy() {
    // console.log('[Start Destroy] Recommendation');
    this.local.clearTimeout(this.timeout1);
    this.destroy$.next();
    this.destroy$.complete();
  }
  modalRef: MatBottomSheetRef<any> | any = null;
  showSeeMore: boolean = false;
  recommendationSeeMore: boolean = true;
  @ViewChild('recommendation_content') recommendation_content!: ElementRef;

  public recommendProduct(selectedProductForRecommend: any, modal: any) {
    this.getRecommendProductOfUser();
    this.selectedProductForRecommend = selectedProductForRecommend;
    this.closeModalByRef();
    this.modalRef = this.modalService.open(modal, {
      size: 'sm',
      ariaLabelledBy: 'modal-basic-title',
      windowClass: 'suggestion',
    });
  }

  public productRecommendSubmit(): void {
    this.local
      .confirm({
        title: 'Support',
        text: 'Do you wish to support this business?',
        icon: 'info',
      })
      .then((res) => {
        if (res.isConfirmed) {
          this.customerService
            .addMemberSupport({
              businessId: this.productData?.enableMemberShop
                ? this.selectedProductForRecommend.appUser.id
                : '',
              type: this.productData?.enableMemberShop ? 'community' : 'biz',
            })
            .subscribe({
              next: (resp: ApiResponse) => {
                this.toastr.success(resp.message);
                this.closeModalByRef();
              },
              error: ({ error }: any) => {
                this.toastr.error(error.message);
              },
            });
        } else {
          this.toastr.info('Support cancelled');
        }
      });
  }

  public get isMobile(): boolean {
    return this.sharedService.isBrowser() && window.innerWidth < 767;
  }

  openRecommendationModal(modal: any) {
    this.youtubeLink = '';
    if (this.isLogin == 0) return this.toastr.error('Please Login First!');
    this.suggestionBase64 = null;
    this.suggestionAttachment = null;
    this.recommendMessage = '';
    if (this.isMobile) {
      this.modalRef = this.bottomSheet.open(modal, {
        scrollStrategy: this.overlay.scrollStrategies.block(),
        panelClass: 'bottom-sheet-1',
      });
    } else {
      this.modalRef = this.modalService.open(modal, {
        ariaLabelledBy: 'modal-basic-title',
        windowClass: 'md my-modal',
      });
    }
  }
  openSuggestionInModal(suggestion, modal) {
    this.selectedRecommendation = suggestion;
    this.selectedRecommendation.comments = [];
    this.getCommentSuggestion();
    if (this.isMobile) {
      this.modalRef = this.bottomSheet.open(modal, {
        scrollStrategy: this.overlay.scrollStrategies.block(),
        panelClass: 'bottom-sheet-1',
      });
    } else {
      this.modalRef = this.modalService.open(modal, {
        windowClass: 'recommendation-modal my-modal sm',
      });

      this.modalRef.result
        .then((result) => {
          console.log('Modal closed with:', result);
          this.modalRef = null;
        })
        .catch((reason) => {
          console.log('Modal dismissed with:', reason);
          this.modalRef = null;
        });
    }

    this.local.clearTimeout(this.timeout1);
    this.timeout1 = setTimeout(() => {
      const contentHeight =
        this.recommendation_content?.nativeElement.scrollHeight;
      if (contentHeight > 12 * 16) {
        this.showSeeMore = true;
        this.recommendationSeeMore = false;
      }
    }, 100);
  }

  public getRecommendProductOfUser() {
    this.currentUserNoRecommendation = 3;
    this.customerService.getUserSupportList().subscribe((resp: ApiResponse) => {
      this.currentUserNoRecommendation =
        this.currentUserNoRecommendation - (resp.body.length || 0);
    });
  }
  uploadProgress: number = 0;
  @ViewChild('RecommendProduct') recommendProductTemplate: any;
  public closeModalByRef() {
    // if (this.modalRef instanceof NgbModalRef) {
    //   this.modalRef.close();
    // } else if (this.modalRef instanceof MatBottomSheetRef) {
    //   this.modalRef.dismiss();
    // }
    this.modalRef?.dismiss();
  }

  submitRecommendation() {
    this.uploadProgress = 0;
    let formData = new FormData();
    let message = this.recommendMessage.trim();
    formData.append('message', message);

    if (this.youtubeLink.length) {
      const youtubeUrl = this.youtubeLink.match(/src="([^"]*)"/);
      if (youtubeUrl != null && youtubeUrl.length > 1) {
        formData.append('image', youtubeUrl[1]);
      } else {
        this.toastr.error('Invalid Youtube URL');
        return;
      }
    } else {
      formData.append('image', this.suggestionAttachment);
    }

    this.productData?.enableMemberShop
      ? formData.append('member_product_id', this.productData.id)
      : formData.append('product_id', this.productData.id);
    formData.append('isRecommendation', 'true');

    if (message) {
      this.auth
        .submitSuggestionMessage(formData, {
          reportProgress: true,
          observe: 'events',
        })
        .subscribe(
          (response: any) => {
            if (response.type === HttpEventType.UploadProgress) {
              // Update progress percentage
              this.uploadProgress = Math.round(
                (100 * response.loaded) / response.total
              );
            } else if (response.type === HttpEventType.Response) {
              this.youtubeLink = '';
              this.toastr.success('Experience Added Successfully');
              this.getProductSuggestions(this.productData.id);
              this.memberNotificationService.getNotification();
              this.uploadProgress = 0;
              this.closeModalByRef();
              // if (this.roleService.roles?.level?.includes('MEMBER_SHOP_REFERRAL')) {
              //   this.recommendProduct(this.productData, this.recommendProductTemplate)
              // } else {
              //   this.modalRef.close();
              // }
            }
          },
          (e) => {
            this.uploadProgress = 0;
            this.toastr.error(e.error.message);
          }
        );
    } else {
      this.toastr.error('Recommendation is empty!');
    }
  }

  public submitSuggestion() {
    if (this.isLogin == 0) {
      return this.toastr.error('Please Login First !');
    }
    let formData = new FormData();
    let message = this.memberMessage.trim();
    formData.append('message', message);
    this.productData?.enableMemberShop
      ? formData.append('member_product_id', this.productData.id)
      : formData.append('product_id', this.productData.id);
    formData.append('type', this.type);

    if (message) {
      this.auth.submitSuggestionMessage(formData).subscribe((response: any) => {
        this.type = '';
        this.toastr.success(response.message);
        this.closeModalByRef();
      });
    } else {
      this.toastr.error('Suggestion is empty!');
    }
  }
  public playVideo(url) {
    const instance = this.modalService.open(VidplayerComponent, {
      size: 'sm',
    });
    instance.componentInstance.videoUrl = url;
  }
  public showMessage = [];
  getProductSuggestions(id: any, page = 1) {
    //console.log('getting product suggestions for product with id', id)
    this.productSuggestions = null;
    if (id) {
      let payload: any = { product_id: id, page: page };

      if (this.productData?.enableMemberShop) {
        payload = { member_product_id: id, page: page };
      }
      this.commonService.countOfExperiences = 0;
      this.auth.getProductRecommendation(payload).subscribe(
        (response: any) => {
          let data = [];
          if (page != 1) {
            data = this.productSuggestions.data;
          }
          this.productSuggestions = response.body;
          this.showMessage = new Array(
            this.productSuggestions?.data?.length ?? 10
          );
          this.showMessage.fill(false);

          this.commonService.countOfExperiences = (
            response?.body.data || []
          ).length;
          this.productSuggestions.data = [
            ...data,
            ...this.productSuggestions.data,
          ];

          this.productSuggestions.data = this.productSuggestions.data.map(
            (i: any, index: Number) => {
              let temp = i;
              if (i.image.includes('youtube')) {
                temp['recommendationType'] = 'youtube';
                temp['image'] = this._sanitizer.bypassSecurityTrustResourceUrl(
                  i.image
                );
              } else if (i.image.includes('.mp4')) {
                temp['recommendationType'] = 'video';
              }

              if (i.isPinned) {
                this.changeRecommend.emit({
                  ...temp,
                  reset: index == 0,
                });
              }
              return temp;
            }
          );

          this.productSuggestions.data.sort((a, b) => {
            if (a.isPinned && !b.isPinned) return -1;
            if (!a.isPinned && b.isPinned) return 1;
            return 0;
          });
        },
        (e) => {
          if (e.status == 400) {
            //this.toastr.error(e.error.message);
          }
        }
      );
    }
  }

  deleteSuggestion(id: number) {
    if (this.isLogin == 0) {
      return this.toastr.error('Please Login First !');
    }
    this.local.alertConfirm({}).then((resp: any) => {
      if (resp.isConfirmed) {
        this.local.alertLoading({});
        this.auth.deleteSuggestion(id).subscribe(
          (response: any) => {
            this.modalRef ? this.closeModalByRef() : '';
            this.toastr.success(response.message);
            this.getProductSuggestions(this.productData.id);
            Swal.close();
          },
          (e) => {
            Swal.close();
            this.toastr.error(e.error.message);
          }
        );
      }
    });
  }

  handlePin() {
    if (this.isLogin == 0) {
      return this.toastr.error('Please Login First !');
    }
    this.local
      .alertConfirm({
        message: 'Are you sure you want to pin this suggestion?',
      })
      .then((resp: any) => {
        if (resp.isConfirmed) {
          this.local.alertLoading({});

          let payload: any = {
            product_id: this.selectedRecommendation.product_id,
            id: this.selectedRecommendation.id,
          };

          if (this.productData?.enableMemberShop) {
            payload = {
              member_product_id: this.selectedRecommendation.member_product_id,
              id: this.selectedRecommendation.id,
            };
          }

          payload.isPinned = this.selectedRecommendation.isPinned;

          this.auth.pinSuggestion(payload).subscribe(
            (response: any) => {
              this.modalRef ? this.closeModalByRef() : '';
              this.toastr.success(response.message);
              this.getProductSuggestions(this.productData.id);
              Swal.close();
            },
            (e) => {
              Swal.close();
              this.toastr.error(e.error.message);
            }
          );
        }
      });
  }

  loadSuggestionMore() {
    this.getProductSuggestions(
      this.productData.id,
      this.productSuggestions.currentPage + 1
    );
  }

  editCommentSuggestion(item: any) {
    item.isEdit = !item.isEdit;
    item.commentText = item.text;
    item.showOption = false;
    item.showReply = false;
    // this.adjustHeightCKEditor()
  }

  editForumMessageReply(event: any, item: any) {
    event.preventDefault();
    item.isEdit = !item.isEdit;
    item.messageEdit = item.message;
    item.showOption = false;

    // this.adjustHeightCKEditor()
  }

  saveCommentSuggestion(parentId: number = 0, item = null, isEdit = false) {
    if (this.isLogin == 0) {
      return this.toastr.error('Please Login First !');
    }
    const value = this.selectedRecommendation;
    if (!value.commentText) {
      if (!item.commentText) {
        return this.toastr.error('Please fill the message');
      }
      {
        value.commentText = item.commentText.trim();
      }
    }

    if (item != null) {
      value.commentText = item.commentText;
    }

    const payload = {
      suggestionId: value.id,
      text: value.commentText,
    };

    if (item && item?.isEdit) {
      payload['id'] = parentId;
    } else {
      payload['parentId'] = parentId;
    }

    this.selectedRecommendation.hasSubmit = true;
    this.auth.suggestionComments(payload).subscribe(
      (response: any) => {
        this.selectedRecommendation.hasSubmit = false;
        this.selectedRecommendation.showCommentBox = false;
        this.toastr.success(response.message);
        this.getProductSuggestions(this.productData.id);
        if (!item) {
          this.getCommentSuggestion();
        } else {
          item.isEdit = false;
          item.text = value.commentText;
        }
      },
      (e) => {
        this.selectedRecommendation.hasSubmit = false;
        //this.toastr.error(e.error.message);
      }
    );
  }

  getCommentSuggestion(refresh = true) {
    const value = this.selectedRecommendation;
    this.auth.suggestionCommentsGet(value).subscribe((response: any) => {
      if (refresh) this.selectedRecommendation.comments = response.body;
      else
        this.selectedRecommendation.comments = [
          ...this.selectedRecommendation.comments,
          ...response.body,
        ];
    });
  }

  deleteCommentSuggestion(id: number) {
    if (this.isLogin == 0) {
      return this.toastr.error('Please Login First !');
    }
    this.local.alertConfirm({}).then((resp: any) => {
      if (resp.isConfirmed) {
        this.local.alertLoading({});
        this.auth.suggestionCommentsDelete(id).subscribe(
          (response: any) => {
            this.selectedRecommendation.hasSubmit = false;
            this.selectedRecommendation.showCommentBox = false;
            this.toastr.success(response.message);
            this.getCommentSuggestion();
            Swal.close();
          },
          (e) => {
            Swal.close();
            this.selectedRecommendation.hasSubmit = false;
            //this.toastr.error(e.error.message);
          }
        );
      }
    });
  }

  isAdmin = () => this.local.getUser()?.role == 'admin';

  hasChecked(data: any) {
    if (!data) {
      return;
    }
    return (
      data.filter(
        (row: any) =>
          row.userId == this.appUserId && row.isAdmin == this.isAdmin()
      ).length > 0
    );
  }

  likeSuggestion(suggestionId: number, data: any) {
    if (this.isLogin == 0) {
      return this.toastr.error('Please Login First !');
    }
    const payload = {
      userId: this.appUserId,
      suggestionId: suggestionId,
      isAdmin: this.isAdmin(),
    };

    if (this.hasChecked(data.suggestionLikes))
      data.suggestionLikes = data.suggestionLikes.filter(
        (row: any) =>
          row.userId != this.appUserId && row.isAdmin != this.isAdmin()
      );
    else data.suggestionLikes = [...data.suggestionLikes, payload];

    // this.initPollLikes()
    this.auth.suggestionLikes(payload).subscribe();
  }

  openReportModal(modal: any, type: any = '') {
    this.memberMessage = '';

    if (this.isMobile) {
      this.modalRef = this.bottomSheet.open(modal, {
        scrollStrategy: this.overlay.scrollStrategies.block(),
        panelClass: 'bottom-sheet-1',
      });
    } else {
      this.modalRef = this.modalService.open(modal, {
        size: 'sm',
        ariaLabelledBy: 'modal-basic-title',
        windowClass: 'suggestion',
      });
    }
  }

  previewSource: string | null = null; // Source for the preview
  previewType: 'image' | 'video' | null = null; // Type of the preview (image or video)

  saveSelectedFile(event: Event): void {
    const input = event.target as HTMLInputElement;

    if (input?.files && input.files.length > 0) {
      const file = input.files[0];
      const fileType = file.type;

      if (fileType.startsWith('image/')) {
        this.previewType = 'image';
        this.previewImage(file);
      } else if (fileType.startsWith('video/')) {
        this.previewType = 'video';
        this.previewVideo(file);
      } else {
        console.error('Unsupported file type:', fileType);
        this.resetPreview();
      }
    }
  }

  previewImage(file: File): void {
    const reader = new FileReader();
    reader.onload = () => {
      this.previewSource = reader.result as string;
      this.suggestionAttachment = file;
    };
    reader.readAsDataURL(file);
  }

  previewVideo(file: File): void {
    // For videos, set the preview source to the object URL
    this.previewSource = URL.createObjectURL(file);
    this.suggestionAttachment = file;
  }

  resetPreview(): void {
    this.previewSource = null;
    this.previewType = null;
  }

  saveSeletedImage(event) {
    let file = event.target.files[0];

    let fileReader = new FileReader();
    fileReader.onload = () => {
      this.suggestionBase64 = fileReader.result;
      this.suggestionAttachment = file;
    };
    fileReader.readAsDataURL(file);
  }

  modalDismissAll() {
    this.modalService.dismissAll();
  }

  public handleError(event: any): void {
    (
      event.target as HTMLImageElement
    ).src = `../../../../../../assets/images/shop/default.png`;
  }

  reportType: string = 'Spam';
  public submitReport(): void {
    if (this.isLogin == 0) {
      this.toastr.error('Please Login First !');
      return;
    }

    let message = this.memberMessage.trim();
    if (message) {
      let payload: any = {
        message: message,
        product_id: this.productData.id,
        type: this.reportType,
        category: 'recommendation',
      };

      this.auth.submitReportMessage(payload).subscribe((response: any) => {
        this.toastr.success(response.message);
        this.closeModalByRef();
        this.type = '';
        this.memberNotificationService.getNotification();
      });
    } else {
      this.toastr.error('Report is empty!');
    }
  }

  openSuggestModal(modal: any, type: any = '') {
    this.memberMessage = '';
    if (this.isMobile) {
      this.modalRef = this.bottomSheet.open(modal, {
        scrollStrategy: this.overlay.scrollStrategies.block(),
        panelClass: 'bottom-sheet-1',
      });
    } else {
      this.modalRef = this.modalService.open(modal, {
        size: 'sm',
        ariaLabelledBy: 'modal-basic-title',
        windowClass: 'suggestion',
      });
    }

    this.type = type;
  }

  loginHere() {
    this.modalService.dismissAll();
    document.getElementById('loginBtn').click();
  }
}
